export class APIRequestResponse<T, U, V, W, X>
{
    singleValue?: T;
    anyParam1?: U;
    anyParam2?: V;
    anyParam3?: W;
    listParam1?: X[];
}